'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var _ = require('lodash');  /* jshint ignore:line */
var Version = require('../../base/Version');  /* jshint ignore:line */
var WebChannelsList = require('./v2/webChannels').WebChannelsList;


/* jshint ignore:start */
/**
 * Initialize the V2 version of FlexApi
 *
 * @constructor Twilio.FlexApi.V2
 *
 * @property {Twilio.FlexApi.V2.WebChannelsList} webChannels - webChannels resource
 *
 * @param {Twilio.FlexApi} domain - The twilio domain
 */
/* jshint ignore:end */
function V2(domain) {
  Version.prototype.constructor.call(this, domain, 'v2');

  // Resources
  this._webChannels = undefined;
}

_.extend(V2.prototype, Version.prototype);
V2.prototype.constructor = V2;

Object.defineProperty(V2.prototype,
  'webChannels', {
    get: function() {
      this._webChannels = this._webChannels || new WebChannelsList(this);
      return this._webChannels;
    }
});

module.exports = V2;
